import { PromiseWithKnownReason } from '@reduxjs/toolkit/src/query/core/buildMiddleware/types';

export const latestAdHocPromises: Record<
  'steps' | 'columns' | 'rows' | 'rowsCount',
  PromiseWithKnownReason<unknown, unknown>
> = {
  steps: Promise.resolve(),
  columns: Promise.resolve(),
  rows: Promise.resolve(),
  rowsCount: Promise.resolve(),
};
